export default {
    url: '/level',
    template: '<user-group-add-level level="vm.level"/>',
    controller (ClassifierResource, CLASSIFIER_ENUM) {
        this.level = new ClassifierResource({ type: CLASSIFIER_ENUM.KEYS.LEVEL });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/add/level/index.js